import IndexTypoContainer from './IndexTypoContainer';

/*
* 문제 선지 컴포넌트
* 각 선지의 Index와 내용을 표시
*/
export default IndexTypoContainer;